import { useContext } from 'react'

import { HugTableContext } from '@/components/lemmala-design-system/table/contexts/hug-table-context'

export const useHugTableContext = () => useContext(HugTableContext)
